import { AnyAction, configureStore } from '@reduxjs/toolkit'
import { persistStore } from 'redux-persist'
import thunkMiddleware, { ThunkDispatch } from 'redux-thunk'

import i18n from 'src/i18n'
import rootReducer from './rootReducer'

const store = configureStore({
  reducer: rootReducer,
  middleware: [thunkMiddleware],
  devTools: false,
})

store.subscribe(() => {
  const currentLanguage = store.getState().app.language
  if (i18n.language !== currentLanguage) {
    i18n.changeLanguage(currentLanguage)
  }
})

export const persistor = persistStore(store)

// Infer the `RootState` and `AppDispatch` types from the store itself
export type AppRootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch & ThunkDispatch<AppRootState, unknown, AnyAction>

export default store

export const selectRootState = (state: AppRootState): AppRootState => state
